import * as React from 'react';
import { Link } from 'react-router-dom';

import ImageHowto1SP from '@/assets/images/guide/img_keirin_howto_1_sp.png';
import ImageHowto1SPWebp from '@/assets/images/guide/img_keirin_howto_1_sp.png?webp';
import ImageHowto1SP2x from '@/assets/images/guide/img_keirin_howto_1_sp@2x.png';
import ImageHowto1SP2xWebp from '@/assets/images/guide/img_keirin_howto_1_sp@2x.png?webp';
import ImageHowto2SP from '@/assets/images/guide/img_keirin_howto_2_sp.png';
import ImageHowto2SPWebp from '@/assets/images/guide/img_keirin_howto_2_sp.png?webp';
import ImageHowto2SP2x from '@/assets/images/guide/img_keirin_howto_2_sp@2x.png';
import ImageHowto2SP2xWebp from '@/assets/images/guide/img_keirin_howto_2_sp@2x.png?webp';
import ImageHowto3SP from '@/assets/images/guide/img_keirin_howto_3_sp.png';
import ImageHowto3SPWebp from '@/assets/images/guide/img_keirin_howto_3_sp.png?webp';
import ImageHowto3SP2x from '@/assets/images/guide/img_keirin_howto_3_sp@2x.png';
import ImageHowto3SP2xWebp from '@/assets/images/guide/img_keirin_howto_3_sp@2x.png?webp';
import ImageHowto4aSP from '@/assets/images/guide/img_keirin_howto_4_1_sp.png';
import ImageHowto4aSPWebp from '@/assets/images/guide/img_keirin_howto_4_1_sp.png?webp';
import ImageHowto4aSP2x from '@/assets/images/guide/img_keirin_howto_4_1_sp@2x.png';
import ImageHowto4aSP2xWebp from '@/assets/images/guide/img_keirin_howto_4_1_sp@2x.png?webp';
import ImageHowto4bSP from '@/assets/images/guide/img_keirin_howto_4_2_sp.png';
import ImageHowto4bSPWebp from '@/assets/images/guide/img_keirin_howto_4_2_sp.png?webp';
import ImageHowto4bSP2x from '@/assets/images/guide/img_keirin_howto_4_2_sp@2x.png';
import ImageHowto4bSP2xWebp from '@/assets/images/guide/img_keirin_howto_4_2_sp@2x.png?webp';
import ImageHowto4cSP from '@/assets/images/guide/img_keirin_howto_4_3_sp.png';
import ImageHowto4cSPWebp from '@/assets/images/guide/img_keirin_howto_4_3_sp.png?webp';
import ImageHowto4cSP2x from '@/assets/images/guide/img_keirin_howto_4_3_sp@2x.png';
import ImageHowto4cSP2xWebp from '@/assets/images/guide/img_keirin_howto_4_3_sp@2x.png?webp';
import ImageHowto4dSP from '@/assets/images/guide/img_keirin_howto_4_4_sp.png';
import ImageHowto4dSPWebp from '@/assets/images/guide/img_keirin_howto_4_4_sp.png?webp';
import ImageHowto4dSP2x from '@/assets/images/guide/img_keirin_howto_4_4_sp@2x.png';
import ImageHowto4dSP2xWebp from '@/assets/images/guide/img_keirin_howto_4_4_sp@2x.png?webp';
import ImageStep1SP from '@/assets/images/guide/nav_race_sp_001.png';
import ImageStep1SPWebp from '@/assets/images/guide/nav_race_sp_001.png?webp';
import ImageStep1SP2x from '@/assets/images/guide/nav_race_sp_001@2x.png';
import ImageStep1SP2xWebp from '@/assets/images/guide/nav_race_sp_001@2x.png?webp';
import ImageStep2SP from '@/assets/images/guide/nav_race_sp_002.png';
import ImageStep2SPWebp from '@/assets/images/guide/nav_race_sp_002.png?webp';
import ImageStep2SP2x from '@/assets/images/guide/nav_race_sp_002@2x.png';
import ImageStep2SP2xWebp from '@/assets/images/guide/nav_race_sp_002@2x.png?webp';
import ImageStep3SP from '@/assets/images/guide/nav_race_sp_003.png';
import ImageStep3SPWebp from '@/assets/images/guide/nav_race_sp_003.png?webp';
import ImageStep3SP2x from '@/assets/images/guide/nav_race_sp_003@2x.png';
import ImageStep3SP2xWebp from '@/assets/images/guide/nav_race_sp_003@2x.png?webp';
import Break from '@/components/elements/Break';
import Button from '@/components/elements/Button/BaseButton';
import Image from '@/components/elements/Image';
import { HASH_RACE } from '@/components/templates/Top';

import {
  ButtonContainer,
  Text,
  TextNote,
  TitleSmall,
  TitleTertiary,
} from '../../style';
import VotingSingleStep, { StepDataType } from '../SingleStep';
import { HowtoImageSP, HowtoVote, Hr } from '../style';
import { VotingContentsProps } from '../type';

const stepData: StepDataType[] = [
  {
    image: (
      <Image
        srcSet={`${ImageStep1SP} 1x, ${ImageStep1SP2x} 2x`}
        mediaSet={[
          {
            srcSet: `${ImageStep1SPWebp} 1x, ${ImageStep1SP2xWebp} 2x`,
            type: 'image/webp',
          },
        ]}
        alt="レース情報画面イメージ"
        aspectRatio={130 / 640}
      />
    ),
    title: 'レース情報',
    text: (
      <>
        まずはレースを予想！
        <br />
        <Link to="/guide/racecard">出走表の見方はこちら</Link>
      </>
    ),
  },
  {
    image: (
      <Image
        srcSet={`${ImageStep2SP} 1x, ${ImageStep2SP2x} 2x`}
        mediaSet={[
          {
            srcSet: `${ImageStep2SPWebp} 1x, ${ImageStep2SP2xWebp} 2x`,
            type: 'image/webp',
          },
        ]}
        alt="投票選択画面イメージ"
        aspectRatio={130 / 640}
      />
    ),
    title: '投票選択',
    text: '賭式や車番を選択し、投票パネルへ追加！',
  },
  {
    image: (
      <Image
        srcSet={`${ImageStep3SP} 1x, ${ImageStep3SP2x} 2x`}
        mediaSet={[
          {
            srcSet: `${ImageStep3SPWebp} 1x, ${ImageStep3SP2xWebp} 2x`,
            type: 'image/webp',
          },
        ]}
        alt="投票パネル画面イメージ"
        aspectRatio={130 / 640}
      />
    ),
    title: '投票パネル',
    text: '投票内容を確認し、投票完了！',
  },
];

interface VotingSingleProps extends VotingContentsProps<HTMLDivElement> {}

const VotingSingleSP: React.FC<VotingSingleProps> = ({ refObj }) => {
  const VoteButton = (
    <ButtonContainer>
      <Link to={`/#${HASH_RACE}`}>
        <Button
          type="button"
          bgColor="primary"
          size="m"
          radius="l"
          height="56px"
          fontWeight="bold"
        >
          さっそく投票する！
        </Button>
      </Link>
    </ButtonContainer>
  );

  return (
    <div ref={refObj}>
      <TitleTertiary>スマートフォン</TitleTertiary>
      <TitleSmall>3つのボタンでカンタン投票！</TitleSmall>
      <VotingSingleStep data={stepData} />
      {VoteButton}
      <Hr />
      <TitleSmall>投票ページの使い方</TitleSmall>
      <Text>
        投票したいレースの「投票」ボタンをタップすると投票ページへ移動します。
      </Text>
      <HowtoVote>
        <dt>1. 投票するレースと賭式の選択</dt>
        <dd>
          <Text>
            投票方法は<b>フォーメーション・BOX・流し・オッズ</b>
            からお好きな方法をお選びください。
            <br />
            賭式は複数選択することができます。
          </Text>
          <HowtoImageSP>
            <Image
              srcSet={`${ImageHowto1SP} 1x, ${ImageHowto1SP2x} 2x`}
              mediaSet={[
                {
                  srcSet: `${ImageHowto1SPWebp} 1x, ${ImageHowto1SP2xWebp} 2x`,
                  type: 'image/webp',
                },
              ]}
              alt="投票するレースと賭式の選択画面イメージ"
              width="100%"
              aspectRatio={734 / 800}
            />
          </HowtoImageSP>
          <TextNote>
            <i>※</i>
            点線⋯競輪場や開催レースを変更したい場合は、こちらをタップすると切り替えられます。
          </TextNote>
        </dd>
        <dt>2. 車番の選択</dt>
        <dd>
          <Text>
            投票したい選手の車番をタップして選択します。もう一度タップすると選択が解除されます。
            <br />
            全選択や全消去、マルチ投票の選択も可能です。
            <br />
            <Link to="/guide/racecard">出走表の見方はこちら</Link>
          </Text>
          <HowtoImageSP>
            <Image
              srcSet={`${ImageHowto2SP} 1x, ${ImageHowto2SP2x} 2x`}
              mediaSet={[
                {
                  srcSet: `${ImageHowto2SPWebp} 1x, ${ImageHowto2SP2xWebp} 2x`,
                  type: 'image/webp',
                },
              ]}
              alt="車番の選択画面イメージ"
              width="100%"
              height="100%"
              aspectRatio={734 / 800}
            />
          </HowtoImageSP>
        </dd>
        <dt>3. 投票パネルへ追加</dt>
        <dd>
          <Text>
            車番を選択すると、車番選択の下部に選択内容が表示され、票数の増減、買い目のオッズ確認や削除をすることができます。
            <Break breakpoint="large" isHidden />
            「投票パネルへ追加する」ボタンをタップすると通知が表示され、選択した買い目が投票パネルへ追加されます。
            <br />
            赤いバッジ内の数字は現在投票パネルに入っている組数です。
          </Text>
          <HowtoImageSP>
            <Image
              srcSet={`${ImageHowto3SP} 1x, ${ImageHowto3SP2x} 2x`}
              mediaSet={[
                {
                  srcSet: `${ImageHowto3SPWebp} 1x, ${ImageHowto3SP2xWebp} 2x`,
                  type: 'image/webp',
                },
              ]}
              alt="投票パネルへ追加画面イメージ"
              width="100%"
              aspectRatio={734 / 800}
            />
          </HowtoImageSP>
          <Text>
            「投票パネル」では、現在投票パネルに追加されている買い目をいつでも確認することができます。
            <br />
            投票パネルへ追加が完了すると、選択した内容は投票選択画面からクリアされます。
            <br />
            続けて投票したい買い目がある場合はもう一度車番選択を行って投票パネルへ追加してください。
          </Text>
        </dd>
        <dt>4. 投票パネルで投票内容を確認して投票</dt>
        <dd>
          <Text>
            投票したい買い目をすべて投票パネルへ追加したら、「投票パネル」ボタンをタップして開きます。
            <br />
            投票パネルへ追加されている買い目が表示され、買い目の修正や削除、口数変更や資金配分が行えます。資金配分は全ての買い目に対してまとめて行うこと可能です。
            <br />
            投票する組番が決まったら「投票確認へ」ボタンをタップします。
          </Text>
          <HowtoImageSP>
            <Image
              srcSet={`${ImageHowto4aSP} 1x, ${ImageHowto4aSP2x} 2x`}
              mediaSet={[
                {
                  srcSet: `${ImageHowto4aSPWebp} 1x, ${ImageHowto4aSP2xWebp} 2x`,
                  type: 'image/webp',
                },
              ]}
              alt="投票パネル、投票確認へボタン画面イメージ"
              width="100%"
              height="100%"
              aspectRatio={734 / 800}
            />
          </HowtoImageSP>
          <Text>
            投票内容・組数・投票金額をよく確認します。
            <br />
            投票内容を修正したい場合は「キャンセル」ボタンをタップすれば先程の投票パネルへ戻ります。
            <br />
            「確定する」ボタンをタップすると、投票が確定します。
          </Text>
          <TextNote>
            <i>※</i>
            投票が確定すると変更や取り消しはできませんのでご注意ください。
          </TextNote>
          <HowtoImageSP>
            <Image
              srcSet={`${ImageHowto4bSP} 1x, ${ImageHowto4bSP2x} 2x`}
              mediaSet={[
                {
                  srcSet: `${ImageHowto4bSPWebp} 1x, ${ImageHowto4bSP2xWebp} 2x`,
                  type: 'image/webp',
                },
              ]}
              alt="投票パネル、確定するボタン画面イメージ"
              width="100%"
              aspectRatio={734 / 800}
            />
          </HowtoImageSP>
          <Text>
            「投票が完了しました」と表示されれば無事投票完了です！
            <br />
            開催中の他のレースを続けて投票することもできます。
          </Text>
          <HowtoImageSP>
            <Image
              srcSet={`${ImageHowto4cSP} 1x, ${ImageHowto4cSP2x} 2x`}
              mediaSet={[
                {
                  srcSet: `${ImageHowto4cSPWebp} 1x, ${ImageHowto4cSP2xWebp} 2x`,
                  type: 'image/webp',
                },
              ]}
              alt="投票パネル、投票完了画面イメージ"
              width="100%"
              aspectRatio={734 / 800}
            />
          </HowtoImageSP>
          <Text>
            「購入車券」をタップすると、投票が完了した車券の組番・オッズ・投票金額などの情報がご確認いただけます。
          </Text>
          <HowtoImageSP>
            <Image
              srcSet={`${ImageHowto4dSP} 1x, ${ImageHowto4dSP2x} 2x`}
              mediaSet={[
                {
                  srcSet: `${ImageHowto4dSPWebp} 1x, ${ImageHowto4dSP2xWebp} 2x`,
                  type: 'image/webp',
                },
              ]}
              alt="購入車券画面イメージ"
              width="100%"
              aspectRatio={734 / 800}
            />
          </HowtoImageSP>
        </dd>
      </HowtoVote>
      {VoteButton}
    </div>
  );
};

export default VotingSingleSP;
